import MerchantSVG from "@design-system/ui-icons/vanilla/Merchant"
import { createIcon } from "../createIcon"

export const MerchantIcon = createIcon(MerchantSVG)
